export default "__VITE_ASSET__85d11af9__"